'use client'

import React from 'react';
import Loading from '../utils/loading';
import MatchCard from './match-card';
import NextMatchCard from './next-match-card';
import { getScheduleData } from '../utils/supabaseData';
import { getTournamentLogo } from '../utils/apiHelper';
import { useSupabaseData } from '@/hooks/useSupabaseData';
import { isPlayoff } from './stage';
import './section-divider.css';

const SectionDivider = ({ label }) => (
  <div className="section-divider animate__animated animate__fadeIn" role="separator">
    <span className="section-divider__line" aria-hidden="true" />
    <span className="section-divider__label">{label}</span>
    <span className="section-divider__line" aria-hidden="true" />
  </div>
);

const Schedule = ({ savedTournament }) => {
  const { data: schedule, loading } = useSupabaseData(
    () => getScheduleData(savedTournament),
    [savedTournament]
  );

  if (loading) {
    return (
      <div className="schedule-table waiting">
        <Loading />
      </div>
    );
  }

  const logoClass = getTournamentLogo();
  const matches = schedule || [];
  const nextMatch = matches.find((m) => !m.result && m.status !== 'abandoned') || null;
  const firstLeagueIdx = matches.findIndex((m) => !isPlayoff(m.stage));
  const firstPlayoffIdx = matches.findIndex((m) => isPlayoff(m.stage));

  return (
    <div className="schedule-table">
      <NextMatchCard match={nextMatch} logoClass={logoClass} />
      {matches.map((match, index) => (
        <React.Fragment key={`match-${match.matchkey || index}`}>
          {index === firstLeagueIdx && <SectionDivider label="League" />}
          {index === firstPlayoffIdx && <SectionDivider label="Playoffs" />}
          <MatchCard
            logoClass={logoClass}
            index={index}
            date={match.date}
            time={match.time}
            matchNumber={match.matchnumber}
            venue={match.venue}
            city={match.city}
            team1={match.team1_flag}
            team2={match.team2_flag}
            won={match.result}
            status={match.status}
            stage={match.stage}
            winnerPoints={match.winnerPoints}
            matchBonusPoints={match.matchBonusPoints}
            matchRevotePoints={match.matchRevotePoints}
            bonusData={match.bonusData}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

export default Schedule;
